/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { AsyncTaskFunction } from 'ember-concurrency';

interface EnableServiceFormArgs {
  readOnly: boolean;
  provisionAutomaticallyTask: AsyncTaskFunction<void, never[]>;
  configureManuallyTask: AsyncTaskFunction<void, never[]>;
  onInAppEnabled?: () => void;
}

export default class EnableServiceForm extends Component<EnableServiceFormArgs> {
  @tracked isRunning = false;

  @action
  onInAppEnabled() {
    this.args.onInAppEnabled?.();
  }

  @action
  onTaskRunning(running: boolean) {
    this.isRunning = running;
  }
}
